import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

import { Carousel } from "@fancyapps/ui/dist/carousel/carousel.esm.js";
import "@fancyapps/ui/dist/carousel/carousel.css";

import { Autoplay } from "@fancyapps/ui/dist/carousel/carousel.autoplay.esm.js";
import "@fancyapps/ui/dist/carousel/carousel.autoplay.css";

Carousel.Plugins.Autoplay = Autoplay;

function dataSlider(){
	const dataSliders = document.querySelectorAll('[data-block="cards-horizontal"] .f-carousel');

	if ( dataSliders.length > 0 ){
		dataSliders.forEach(dataSlider => {
			new Carousel(dataSlider, {
				Dots: true,
				Navigation: false,
				slidesPerPage: 1,
				spacing: 50,
				friction: 0.8,
				Autoplay: {
					enabled: true,
					timeout: 3000,
					pauseOnHover: true,
					showProgress: false
				}
			});
		});
	}
}

function gallery(){
	const galleries = document.querySelectorAll('[data-block="carousel-gallery"] .f-carousel');

	if ( galleries.length > 0 ){
		galleries.forEach(gallery => {
			new Carousel(gallery, {
				Dots: false,
				slidesPerPage: 1,
				Autoplay: {
					enabled: true,
					timeout: 3000,
					pauseOnHover: true,
					showProgress: false
				},
				on: {
					'Panzoom.beforeTransform': (carousel) => {
						carousel.slides.map((slide) => {					
							slide.el.style.setProperty( '--f-aspect-ratio', '410/555' )
						});
					},
					'Panzoom.ready': (carousel) => {
						if ( ! carousel.viewport.classList.contains('is-draggable')) {
							// Not draggable, so no need for the custom cursors.
							const customCursors = carousel.container.closest('[data-block="carousel-gallery"]').querySelector('[data-name="gallery-custom-cursors"]');
							const followingArea = carousel.container.closest('[data-name="following-cursor-area"]');
							if ( customCursors ) {
								customCursors.style.display = 'none';
								followingArea.classList.remove('cursor-none');
							}
						}
					}
				}
			});
		});
	}
}

function overflowSlider(){
	const overflowSliders = document.querySelectorAll('[data-name="overflow-slider"] .f-carousel');

	if ( overflowSliders.length > 0 ){
		overflowSliders.forEach(overflowSlider => {
			const carousel = new Carousel(overflowSlider, {
				Dots: false,
				Navigation: false,
				infinite: false,
				center: false,
				slidesPerPage: 'auto',
			});

			// Prevent glitchy dragging when targeting the link inside the slide.
			overflowSlider.querySelectorAll('& .f-carousel__slide a').forEach(element => {
				element.addEventListener('dragstart', e => e.preventDefault());
			});
			
			
			// Force stop autoplay using a timeout to ensure it runs after initialization
			setTimeout(() => {
				// Try multiple approaches to stop autoplay
				if (carousel.plugins && carousel.plugins.Autoplay) {
					carousel.plugins.Autoplay.stop();
					carousel.plugins.Autoplay.detach();
				}
				
				// Also try to remove any autoplay timers from the DOM element
				const autoplayElements = overflowSlider.querySelectorAll('.f-carousel__autoplay');
				autoplayElements.forEach(el => el.remove());
				
				// Clear any potential timers
				if (carousel._autoplayTimer) {
					clearTimeout(carousel._autoplayTimer);
					carousel._autoplayTimer = null;
				}
			}, 100);

		});
	}
}

function overflowSliderCentered(){
	const overflowSliders = document.querySelectorAll('[data-name="overflow-slider-centered"] .f-carousel');

	if ( overflowSliders.length > 0 ){
		overflowSliders.forEach(overflowSlider => {
			const carousel = new Carousel(overflowSlider, {
				Dots: false,
				Navigation: false,
				infinite: false,
				center: true,
				slidesPerPage: 1,
				initialPage: 1,
				Autoplay: {
					autoStart: false,
					timeout: 4000,
					pauseOnHover: true,
					showProgress: false
				},
			});

			// Prevent glitchy dragging when targeting the link inside the slide.
			overflowSlider.querySelectorAll('& .f-carousel__slide a').forEach(element => {
				element.addEventListener('dragstart', e => e.preventDefault());
			});
		});
	}
}

function sliders(){
	dataSlider()
	gallery()
	overflowSlider()
	overflowSliderCentered()
}

export { sliders };
